import { FC, useState } from 'react';
import { FilterOptionType, FilterProps } from './types';

import { DesktopFilter } from './DesktopFilter';
import { MobileFilter } from './MobileFilter';
import { useResponsiveScreen } from 'hooks/useWindowSize';

const LocalFilter: FC<FilterProps> = ({
	onChange,
	options,
	selectedOption,
	responsiveSecondary,
	secondaryStyle,
	punchupStyle,
}: FilterProps) => {
	const [isOpened, setIsOpened] = useState(false);
	const isLargeScreen = useResponsiveScreen();

	const onClickSelect = () => setIsOpened((prevState) => !prevState);

	const onClickOption = (selectedValue: FilterOptionType) => {
		onChange(selectedValue);
	};

	return (
		<>
			{isLargeScreen ? (
				<DesktopFilter
					selectedOption={selectedOption}
					onClickSelect={onClickSelect}
					onClickOption={onClickOption}
					isOpened={isOpened}
					isLargeScreen={isLargeScreen}
					options={options}
					secondaryStyle={secondaryStyle}
					punchupStyle={punchupStyle}
				/>
			) : (
				<MobileFilter
					responsiveSecondary={responsiveSecondary}
					onClickSelect={onClickSelect}
					onClickOption={onClickOption}
					isOpened={isOpened}
					isLargeScreen={isLargeScreen}
					options={options}
					selectedOption={selectedOption}
				/>
			)}
		</>
	);
};

export { LocalFilter };
